<div class="cv-photo-car-container">
	<div *ngIf="isSorted && !ruleType" class="cv-photo-car-container__sorter-text">
		{{ 'Result for sorted photos' }}
	</div>
	<div
		#cardElement
		[ngClass]="{
			card: true,
			'card-all': cardType === photoCardState.ALL,
			'card-base': cardType !== photoCardState.ALL
		}"
		*ngFor="let photo of photosCollection; let i = index"
	>
		<div class="card-header">
			<cv-gallery *ngIf="photo.path.length > 0" [album]="photo.path" [options]="galleryOptions"></cv-gallery>
			<!--<ngx-gallery class="ngx-gallery" [options]="galleryOptions" [images]="photo.path"></ngx-gallery>-->
		</div>

		<div
			class="card-body"
			[ngSwitch]="cardType"
			(click)="selectedCard(cardElement, i, photo)"
			*ngIf="cardType !== photoCardState.SKETCH"
		>
			<cv-photo-tab
				[info]="photo"
				[ruleType]="ruleType"
				[SchemaType]="SchemaType"
				*ngSwitchCase="photoCardState.ALL"
			></cv-photo-tab>
			<cv-photo-base-content
				[info]="photo"
				(getCardContent)="setPhotoInfo($event)"
				[contentType]="cardType"
				*ngSwitchDefault
			></cv-photo-base-content>
		</div>
		<div class="card-footer text-muted" [hidden]="true">
			<span class="btn cv-photo-car-container__review-indicator">
				review
			</span>
			<span class="cv-photo-car-container__review-text">
				Rules to review
			</span>
		</div>
	</div>
	<hr *ngIf="isSorted" class="cv-photo-car-container__sorter-divider" />
</div>
